const TOOL_LIST_APPEAR_DURATION_MS = 300;
const toolListCls = "_61tah3fl8";
const toolCls = "_61tvv4e2e";
const toolButtonCls = "_61tm0u9m9";
const guideBubbleWrapperCls = "_61gjs9b7f";

export { TOOL_LIST_APPEAR_DURATION_MS, guideBubbleWrapperCls, toolButtonCls, toolCls, toolListCls };
import "./root.tools.style.linaria.module.css";
//# sourceMappingURL=root.tools.style.js.map
